module.exports = __webpack_public_path__ + "static/full01-c479a6dc5c5817cd5eb1caa30313de60.png";